import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const ORG_NAV_KEYS = new Set(['farmId', 'plotId', 'patchId'])

/**
 * Sets org navigation params (farmId/plotId/patchId) while preserving all other
 * URL params (e.g. seasonId). Pass null or undefined for a key to omit/remove it.
 *
 * Replaces direct setSearchParams({...}) calls which would wipe non-org params.
 *
 * @returns {(orgParams: Record<string, string | null | undefined>) => void}
 */
export const useSetOrgParams = () => {
  const [, setSearchParams] = useSearchParams()

  return useCallback((orgParams) => {
    setSearchParams(prev => {
      const next = new URLSearchParams()
      // Preserve all non-org params (seasonId, etc.)
      for (const [key, value] of prev.entries()) {
        if (!ORG_NAV_KEYS.has(key)) next.set(key, value)
      }
      // Apply provided org params — null/undefined = omit (effectively deletes)
      Object.entries(orgParams).forEach(([key, value]) => {
        if (value != null) next.set(key, value)
      })
      return next
    })
  }, [setSearchParams])
}
